module.exports = __webpack_public_path__ + "img/e772cceedc4e84b7791e4649e9c02e03.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo4.png
// module id = 912
// module chunks = 5